import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { UnlinkParentChildInvestigationCommand } from './unlink-parent-child-investigation.command';
import { UnlinkParentChildInvestigationResult } from './unlink-parent-child-investigation.result';

export type { UnlinkParentChildInvestigationCommand } from './unlink-parent-child-investigation.command';
export type { UnlinkParentChildInvestigationResult } from './unlink-parent-child-investigation.result';

@Injectable({ providedIn: 'root' })
export class UnlinkParentChildInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: UnlinkParentChildInvestigationCommand): Observable<UnlinkParentChildInvestigationResult> {
    return this._repository.unlinkParentChildInvestigation(
      command.investigationId,
      command.linkedInvestigationId,
    ).pipe(
      map(() => ({ success: true })),
      catchError((error) => throwError(() => error)),
    );
  }
}
